import { defineStore } from 'pinia'
import { fetchWrapper } from '@/helpers/fetch-wrapper';
import { ref } from 'vue'

const baseUrl = `${import.meta.env.VITE_BASE_URL}`;

export const useDoneProductsStore = defineStore('doneproducts', () => {
  const doneProducts = ref([])
  const doneProductsForSales = ref([])
  const doneProductsInWh = ref([])
  const doneProductsInWhIncomes = ref([])
  const doneProductsInWhExpenditures = ref([])



  async function fetchDoneProducts(query = null) {
    let url = new URL(`${baseUrl}/doneproducts/doneproducts/`)
    url.searchParams.set('limit', '100000')
    if (query != null) {
      try {
        query.forEach((value, key) => url.searchParams.set(key, value))
      } catch (err) {
        console.log(err)
      }
    }
    return new Promise((resolve, reject) => {
      fetchWrapper.get(new String(url)).then((result) => {
        const results = result?.results
        doneProducts.value = results
        resolve(results)
      }).catch((error) => {
        reject(error)
      });
    })
  }
  async function fetchDoneProductsForSales(query = null) {
    let url = new URL(`${baseUrl}/doneproducts/doneproducts/sales/`)
    url.searchParams.set('limit', '100000')
    if (query != null) {
      try {
        query.forEach((value, key) => url.searchParams.set(key, value))
      } catch (err) {
        console.log(err)
      }
    }
    return new Promise((resolve, reject) => {
      fetchWrapper.get(new String(url)).then((result) => {
        const results = result?.results
        doneProductsForSales.value = results
        resolve(results)
      }).catch((error) => {
        reject(error)
      });
    })
  }
  async function addDoneProduct(doneProduct) {
    return new Promise((resolve, reject) => {
      fetchWrapper.post(`${baseUrl}/doneproducts/doneproducts/`, doneProduct).then((doneProduct) => {
        const results = [doneProduct, ...doneProducts.value]
        doneProducts.value = results
        resolve('ok')
      }).catch((error) => {
        reject(error)
      });
    }
    )
  }
  async function updateDoneProduct(doneProductId, doneProduct) {
    return new Promise((resolve, reject) => {
      fetchWrapper.patch(`${baseUrl}/doneproducts/doneproducts/${doneProductId}/`, doneProduct).then((doneProduct) => {
        const results = doneProducts.value
        const doneProductIndex = results.findIndex(doneProduct => doneProduct.id === doneProductId)
        results[doneProductIndex].price = doneProduct.price
        doneProducts.value = results
        resolve('ok')
      }).catch((error) => {
        reject(error)
      });
    }
    )
  }
  async function fetchDoneProductsWarehouse(query = null) {
    let url = new URL(`${baseUrl}/doneproducts/doneproducts_in_warehouse/`)
    url.searchParams.set('limit', '100000')
    if (query != null) {
      try {
        query.forEach((value, key) => url.searchParams.set(key, value))
      } catch (err) {
        console.log(err)
      }
    }
    return new Promise((resolve, reject) => {
      fetchWrapper.get(new String(url)).then((result) => {
        const results = result?.results
        doneProductsInWh.value = results
        resolve(results)
      }).catch((error) => {
        reject(error)
      });
    })
  }
  async function fetchDoneProductInWarehouse(id) {
    let url = new URL(`${baseUrl}/doneproducts/doneproducts_in_warehouse/${id}/`)
    return new Promise((resolve, reject) => {
      fetchWrapper.get(new String(url)).then((result) => {
        doneProductsInWh.value = result
        resolve(result)
      }).catch((error) => {
        reject(error)
      });
    })
  }
  async function fetchDoneProductInWarehouseTotalCost() {
    let url = new URL(`${baseUrl}/doneproducts/doneproducts_in_warehouse/get_total_cost/`)
    return new Promise((resolve, reject) => {
      fetchWrapper.get(new String(url)).then((result) => {
        resolve(result)
      }).catch((error) => {
        reject(error)
      });
    })
  }
  async function fetchDoneProductWarehouseIncomes(query = null) {
    let url = new URL(`${baseUrl}/doneproducts/doneproducts_in_warehouse_incomes/`)
    url.searchParams.set('limit', '100000')
    if (query != null) {
      try {
        query.forEach((value, key) => url.searchParams.set(key, value))
      } catch (err) {
        console.log(err)
      }
    }
    return new Promise((resolve, reject) => {
      fetchWrapper.get(new String(url)).then((result) => {
        const results = result?.results
        doneProductsInWhIncomes.value = results
        resolve(results)
      }).catch((error) => {
        reject(error)
      });
    })
  }
  async function fetchDoneProductWarehouseExpenditures(query = null) {
    let url = new URL(`${baseUrl}/doneproducts/doneproducts_in_warehouse_expenditures/`)
    url.searchParams.set('limit', '100000')
    if (query != null) {
      try {
        query.forEach((value, key) => url.searchParams.set(key, value))
      } catch (err) {
        console.log(err)
      }
    }
    return new Promise((resolve, reject) => {
      fetchWrapper.get(new String(url)).then((result) => {
        const results = result?.results
        doneProductsInWhExpenditures.value = results
        resolve(results)
      }).catch((error) => {
        reject(error)
      });
    })
  }
  return {
    doneProducts,
    doneProductsInWh,
    doneProductsInWhIncomes,
    doneProductsInWhExpenditures,
    doneProductsForSales,
    fetchDoneProducts,
    fetchDoneProductsForSales,
    addDoneProduct,
    updateDoneProduct,
    fetchDoneProductsWarehouse,
    fetchDoneProductInWarehouse,
    fetchDoneProductInWarehouseTotalCost,
    fetchDoneProductWarehouseIncomes,
    fetchDoneProductWarehouseExpenditures
  }
})
